import { render, staticRenderFns } from "./DataExportNotification.vue?vue&type=template&id=df094450"
import script from "./DataExportNotification.vue?vue&type=script&lang=js"
export * from "./DataExportNotification.vue?vue&type=script&lang=js"
import style0 from "./DataExportNotification.vue?vue&type=style&index=0&id=df094450&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports